import React, { useCallback, useEffect } from "react";
import {
  getUserDataSelector,
  logout,
  useAuthenticationDispatch,
} from "@quest-finance/quest-fe-shared/dist/auth";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router";
import {
  hasAccessToAssessmentAccreditations,
  hasAccessToAssessmentApplications,
  hasAccessToClients,
  hasAccessToMoveApplication,
  hasAccessToPayment,
  hasAccessToRoles,
  hasAccessToUsers,
} from "../../../iam/utils/permissions";

const Home: React.FC = () => {
  const authDispatch = useAuthenticationDispatch();
  const userData = useSelector(getUserDataSelector);
  const navigate = useNavigate();
  const redirect = useCallback(() => {
    let redirectPath = "";

    if (userData) {
      if (hasAccessToAssessmentApplications(userData.permissions)) {
        redirectPath = "/assessment/assessments/applications";
      } else if (hasAccessToAssessmentAccreditations(userData.permissions)) {
        redirectPath = "/assessment/assessments/accreditations";
      } else if (hasAccessToClients(userData.permissions)) {
        redirectPath = "/iam/clients";
      } else if (hasAccessToUsers(userData.permissions)) {
        redirectPath = "/iam/users";
      } else if (hasAccessToRoles(userData.permissions)) {
        redirectPath = "/iam/roles";
      } else if (hasAccessToMoveApplication(userData.permissions)) {
        redirectPath = "/application/applications/move";
      } else if (hasAccessToPayment(userData.permissions)) {
        redirectPath = "/payment/aba/process";
      }
    }

    if (redirectPath) {
      navigate(redirectPath, { replace: true });
    } else {
      authDispatch(logout());
    }
  }, [userData, authDispatch, navigate]);

  useEffect(() => {
    redirect();
  }, [redirect]);

  return <></>;
};

export default Home;
